import { useTranslation } from "react-i18next";

import { showActionAlert } from "@components/molecules/alert";
import type { ID } from "@constants";
import { NoShowOptions } from "@components/organisms/appointmentCard/components/appointmentHelper/noShowOptions";

export const useNoShowAppointmentFunc = (id: ID, isCancel?: boolean) => {
  const { t } = useTranslation("form");

  return () =>
    showActionAlert({
      title: t(isCancel ? "no_show_cancel_appointment" : "no_show_appointment"),
      content: t(
        isCancel
          ? "no_show_cancel_appointment_text"
          : "no_show_appointment_text",
      ),
      noButtons: true,
      approveTitle: t("no_show_appointment"),
      children: <NoShowOptions id={id} />,
    });
};
